module.exports = "<div *ngIf=\"availableTags\">\r\n  Tags:\r\n  <ul class=\"tag-list\">\r\n    <li *ngFor=\"let tag of availableTags\" (click)=\"toggleTag(tag)\"><app-single-tag [selected]=\"(selectedTags.indexOf(tag) > -1)\" [tag]=\"tag\"></app-single-tag></li>\r\n    <li *ngIf=\"selectedTags.length > 0\" (click)=\"clearSelectedTags()\"><span class=\"tag clear\"><i class=\"fas fa-times\"></i> Clear</span></li>\r\n  </ul>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/tags/available-tags/available-tags.component.html
// module id = ./src/app/tags/available-tags/available-tags.component.html
// module chunks = main